import React from 'react';
import PropTypes from 'prop-types';
import { connect, Provider, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import '../../scss/app.scss';
import '../../css/app.css';
import Router from './Router/index';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import { Backdrop, CircularProgress } from '@mui/material';
import SessionTimeout from './SessionTimeout';
import { getOrderPreferences } from 'src/redux/actions/orderPreferencesActions';
import { HelmetProvider } from 'react-helmet-async';

// import jwt_decode from 'jwt-decode';
// import PndRestApi from 'src/utils/pnd/PndRestApi';
// import HubLogin from '../PnD/Landing';

i18n.init(i18nextConfig);
const ThemeComponent = ({ children, themeName }) => {
  const theme = createTheme({
    palette: {
      type: themeName === 'theme-dark' ? 'dark' : 'light',
    },
  });
    return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};
ThemeComponent.propTypes = {
  children: PropTypes.shape().isRequired,
  themeName: PropTypes.string.isRequired,
};
const ConnectedThemeComponent = connect(state => ({ themeName: state.theme.className }))(ThemeComponent);

const Loader = ({ children, stateName }) => {
  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={stateName}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </>
  );
};


const LoaderComponent = connect(state => ({ stateName: state.loader.isLoading }))(Loader);

const AuthInitializer = () => {
  const dispatch = useDispatch();
  const { data, isFetching } = useSelector(state => state.orderPreferences);

  React.useEffect(() => {
    const token = localStorage.getItem('access_token');
    // Only fetch if we have a token, no data, and aren't currently fetching
    if (token && !data && !isFetching) {
      console.log('App: Fetching orderPreferences on load...');
      dispatch(getOrderPreferences());
    }
  }, [dispatch]);

  return null;
};

const App = () => {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <AuthInitializer />
            <LoaderComponent>
              <ScrollToTop>
                <ConnectedThemeComponent>
                  <SessionTimeout>
                    <Router />
                  </SessionTimeout>
                </ConnectedThemeComponent>
              </ScrollToTop>
            </LoaderComponent>
          </I18nextProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
};

export default App;